<template>
  <div class="a-usps">
    <ul class="mt-md-4 list-unstyled p-0">
      <li 
        v-for="(usp,index) in usps" 
        :key="index"
        class="d-flex mb-2 text-dark"
      >
        <base-icon class="my-md-auto mr-3 text-primary" icon="check" />
        <span class="a-usps__text">{{ usp }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import BaseIcon from '@/components/atoms/BaseIcon';

export default {
  name: 'Usps',
    components: {
    BaseIcon
  },
   props: {
    usps: {
      type: Array,
      default () {
        return [];
      },
    },
  },
};
</script>
